import React, { Component } from 'react'
import PropTypes from 'prop-types'
import RichTextEditor from '@/ui/RTE/Medium'
import classNames from '@/helpers/classNames'
import InlineEdit from '@/ui/Input/Content'
import {
  RTE as RteText,
  HEADER as HeaderText,
  BUTTON as ButtonText,
} from '@/state/types/defaultLabel'

class TextBlock extends Component {
  static displayName = 'Card / Text only'
  static propTypes = {
    item: PropTypes.object.isRequired,
    cta: PropTypes.bool,
  }
  static defaultProps = {
    cta: false,
  }

  render() {
    const { theme, item, cta, active, onChange } = this.props
    const { id, text = RteText, header = HeaderText, buttontext = ButtonText } = item
    return (
      <div className={classNames(theme, 'renderpreview', 'text-preview')}>
        <InlineEdit
          tagName="h1"
          textual
          selectText={HeaderText}
          html={header}
          onChange={(e, value) => onChange(item, 'header', value)}
        />
        <Choose>
          <When condition={active}>
            <div id="toolbar" style={{ position: 'absolute', marginTop: '-21px' }} />
            <RichTextEditor
              id="text"
              name="text"
              key={`rte${id}`}
              selectText={RteText}
              value={text}
              onChange={value => onChange(item, 'text', value)}
            />
          </When>
          <Otherwise>
            <span dangerouslySetInnerHTML={{ __html: text || RteText }} />
          </Otherwise>
        </Choose>
        <div className={theme['innerwrap']}>
          <If condition={cta}>
            <button
              className={classNames(theme, 'button', 'button-outline')}
              style={{ marginTop: '24px', padding: '16px' }}
            >
              {buttontext}
            </button>
          </If>
        </div>
      </div>
    )
  }
}

export default TextBlock



// WEBPACK FOOTER //
// ./ui/Blocks/Text.js